export default {
  fillBorder: 'Remplir l\'élément entier lors de l\'affichage uniquement de l\'icône',
  validation: {
    iconTitleRegex: 'Le champ ne doit pas contenir de caractères : $ et .',
  },
};
